import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/customers/$customerId/_layout/')({
  // 顧客詳細のデフォルト着地はプロフィールタブ。利用機能タブは
  // `/customers/$customerId/target-nodes` へ分離した。
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/customers/$customerId/profile',
      params: {
        customerId: params.customerId
      }
    });
  }
});